module.exports = __webpack_public_path__ + "img/emoji_57.c20b1cd7.png";